/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const moonbeam_chain_about = () => `Moonbeam is an EVM-compatible smart contracts platform built in the Polkadot ecosystem. It's designed for seamless compatibility with Ethereum tooling to provide a user-friendly environment for porting existing and developing new dApps. Also, as the biggest Polkadot parachain Moonbeam encourages cross-chain communication with other parachains.`
